import type { Custodian } from 'models/custodian';

export type SecondaryMarketClientActions =
  | SecondaryMarketAstroClientRequested
  | SecondaryMarketReferentialAstroClientFetched
  | SecondaryMarketReferentialAstroClientFetchingFailed
  | SecondaryMarketReferentialAstroClientNotFound;

// ////////////////////////////////////

export function secondaryMarketAstroClientRequested(tabId: string, clientId: string) {
  return {
    type: 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_REQUESTED' as const,
    clientId,
    tabId,
  };
}
export type SecondaryMarketAstroClientRequested = ReturnType<typeof secondaryMarketAstroClientRequested>;

/////////////////////////////////////////////
export function secondaryMarketReferentialAstroClientFetched(clientId: string, custodians: Custodian[]) {
  return {
    type: 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_FETCHED' as const,
    clientId,
    custodians,
  };
}

export type SecondaryMarketReferentialAstroClientFetched = ReturnType<
  typeof secondaryMarketReferentialAstroClientFetched
>;

/////////////////////////////////////////////

export function secondaryMarketReferentialAstroClientFetchingFailed(clientId: string, error: string) {
  return {
    type: 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_FETCH_FAILED' as const,
    clientId,
    error,
  };
}

export type SecondaryMarketReferentialAstroClientFetchingFailed = ReturnType<
  typeof secondaryMarketReferentialAstroClientFetchingFailed
>;

/////////////////////////////////////////////

export function secondaryMarketReferentialAstroClientNotFound(clientId: string) {
  return {
    type: 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_FETCH_NOT_FOUND' as const,
    clientId,
  };
}

export type SecondaryMarketReferentialAstroClientNotFound = ReturnType<
  typeof secondaryMarketReferentialAstroClientNotFound
>;
